// @systeme: contrat
// L'écran Moi : profil, espace, abonnement, compteurs.
import { z } from 'zod';
import { SchemaEspaceResume, SchemaUtilisateur } from './auth.js';
import { SchemaEtatQuota } from './quotas.js';
import { SchemaDroitPlan, SchemaInterrupteurs, SchemaZoneScolaire } from '../enumerations.js';
export const SchemaReponseMoi = z.object({
    utilisateur: SchemaUtilisateur,
    espace: SchemaEspaceResume,
    fonctionnalites: SchemaInterrupteurs.default({}),
    quotas: z.array(SchemaEtatQuota),
    droits: z.array(SchemaDroitPlan),
});
export const SchemaMajProfil = z.object({
    prenom: z.string().trim().min(1).max(60).optional(),
    nomEspace: z.string().trim().min(1).max(60).optional(),
    /** La zone scolaire du foyer ; null pour l'effacer. */
    zoneScolaire: SchemaZoneScolaire.nullable().optional(),
});
//# sourceMappingURL=moi.js.map